import { ReactElement } from "react";

import { ReactComponent as SvgExclamation } from "images/icon_exclamation.svg";
import { ReactComponent as SvgQuestion } from "images/icon_question.svg";

export function IconExclamation(): ReactElement | null {
  return (
    <SvgExclamation
      style={{
        width: "1rem",
        height: "1rem",
      }}
    />
  );
}

export function IconQuestion(): ReactElement | null {
  return (
    <SvgQuestion
      style={{
        width: "1rem",
        height: "1rem",
      }}
    />
  );
}
